"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adobeSetProduct = exports.adobeSendData = exports.adobeScrollBottom = exports.adobeLinkClickObject = void 0;
/**
 * AdobeDotcomLoggerUtil: Contains helper functions for Adobe Analytics data capture.
 */

/**
 * Generic function to send object full of data to Adobe.
 *
 * @param { object } adobeObject
 */
var adobeSendData = function adobeSendData() {
  var adobeObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (adobeObject !== null) {
    window.__analyticsChangeContext = window.__analyticsChangeContext || [];
    window.__analyticsChangeContext.push(adobeObject);
  }
};

/**
 * Creates an Adobe object for "link_click" eventType.
 *
 * @param {} props
 */
exports.adobeSendData = adobeSendData;
var adobeLinkClickObject = function adobeLinkClickObject(props) {
  var section = props.section,
    title = props.title,
    url = props.url;
  var eventData = {
    event: {
      eventType: 'link_click'
    },
    link: {
      linkSection: section,
      linkTitle: title
    }
  };
  if (url !== undefined) {
    eventData.link.linkDestinationUrl = url;
  }
  return eventData;
};

/**
 * Sets product data in digitalData object.
 *
 * @param { string } productLine
 */
exports.adobeLinkClickObject = adobeLinkClickObject;
var adobeSetProduct = function adobeSetProduct(productLine) {
  window.digitalData = window.digitalData || {};
  window.digitalData.product = window.digitalData.product || {};
  window.digitalData.product.productLine = productLine;
};

/**
 * Detects if visitor has scrolled to bottom of content/page.
 * Pass in a class/ID/etc for a container that is at the bottom of where you want to track
 * Add a container or use a footer element, etc.
 * Once this container is reached, the analytics passed in gets sent.
 *
 * Code mostly lifted from:
 * https://git.autodesk.com/dpe/dh-aknwebsite/blob/master/docroot/sites/all/themes/autodesk_foundation5/js/analytics/analytics_datalayer.js#L621
 *
 * Related tracking wiki: https://wiki.autodesk.com/display/BAR/AKN+Scroll+To+Content+Bottom+Tracking
 *
 * @param {string} containerElement
 * @param {string} adobeObject
 */
exports.adobeSetProduct = adobeSetProduct;
var adobeScrollBottom = function adobeScrollBottom(containerElement, adobeObject) {
  if (!('IntersectionObserver' in window)) {
    return;
  }
  var sectionToTrack = document.querySelector(containerElement);

  // do nothing if there is no Element found
  if (!sectionToTrack) {
    return;
  }
  var observer = new window.IntersectionObserver(
  // eslint-disable-next-line no-shadow
  function (entries, observer) {
    // We are only observing one thing, so get the one thing from the entries array parameter
    var entry = entries[0];
    // Props on the entry supplied by the API, isIntersecting tells us if it passed the "intersection threshold"
    if (entry.isIntersecting) {
      // In here means it is "ENTERED" and it is "VISIBLE"
      adobeSendData(adobeObject);
      observer.unobserve(sectionToTrack);
    }
  }, {
    rootMargin: '0px',
    threshold: 0 // Triggered as soon as container becomes visible in viewport.
  });

  observer.observe(sectionToTrack);
};
exports.adobeScrollBottom = adobeScrollBottom;